<template>
  <div class="video_playback" v-if="isVisible">
    <button class="video_playback_close" @click="closeDetail">&times;</button>
    <video class="video_content" :src="videoUrl" controls autoplay muted loop></video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: true // 控制组件自身显示
    };
  },
  props: { 
    videoUrl: {
      type: String,
      default: 'https://download.hecoos.com/enlightv/2025-17/479f37c97440264c647fb58826abc891.mp4'
    }
  },
  methods: {
    closeDetail() {
      this.isVisible = false;
      this.$emit('close'); // 触发关闭事件通知父组件
    }
  }
};
</script>

<style lang="scss" scoped>
.video_playback {
  width: 100%;
  height: 100vh;
  background-color: #030302;
  position: fixed; /* 改为fixed定位，覆盖整个视口 */
  top: 0;
  left: 0;
  z-index: 9999; /* 确保在最上层 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .video_playback_close {
    width: 54px;
    height: 54px;
    line-height: 54px;
    border-radius: 50%;
    font-size: 24px;
    color: #fff;
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10000;
  }

  .video_content {
    display: block;
    width: 80%;
    max-width: 1280px;
    height: auto;
    max-height: 80vh;
  }
}
</style>